var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6888_15744",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6888_15744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8875 12.825C5.525 12.3375 6.2375 11.9531 7.025 11.6719C7.8125 11.3906 8.6375 11.25 9.5 11.25C10.3625 11.25 11.1875 11.3906 11.975 11.6719C12.7625 11.9531 13.475 12.3375 14.1125 12.825C14.55 12.3125 14.8906 11.7312 15.1344 11.0812C15.3781 10.4312 15.5 9.7375 15.5 9C15.5 7.3375 14.9156 5.92187 13.7469 4.75312C12.5781 3.58437 11.1625 3 9.5 3C7.8375 3 6.42187 3.58437 5.25312 4.75312C4.08437 5.92187 3.5 7.3375 3.5 9C3.5 9.7375 3.62187 10.4312 3.86562 11.0812C4.10937 11.7312 4.45 12.3125 4.8875 12.825ZM9.5 9.75C8.7625 9.75 8.14062 9.49687 7.63437 8.99062C7.12812 8.48437 6.875 7.8625 6.875 7.125C6.875 6.3875 7.12812 5.76562 7.63437 5.25937C8.14062 4.75312 8.7625 4.5 9.5 4.5C10.2375 4.5 10.8594 4.75312 11.3656 5.25937C11.8719 5.76562 12.125 6.3875 12.125 7.125C12.125 7.8625 11.8719 8.48437 11.3656 8.99062C10.8594 9.49687 10.2375 9.75 9.5 9.75ZM9.5 16.5C8.4625 16.5 7.4875 16.3031 6.575 15.9094C5.6625 15.5156 4.86875 14.9812 4.19375 14.3062C3.51875 13.6312 2.98437 12.8375 2.59062 11.925C2.19687 11.0125 2 10.0375 2 9C2 7.9625 2.19687 6.9875 2.59062 6.075C2.98437 5.1625 3.51875 4.36875 4.19375 3.69375C4.86875 3.01875 5.6625 2.48437 6.575 2.09062C7.4875 1.69687 8.4625 1.5 9.5 1.5C10.5375 1.5 11.5125 1.69687 12.425 2.09062C13.3375 2.48437 14.1312 3.01875 14.8062 3.69375C15.4812 4.36875 16.0156 5.1625 16.4094 6.075C16.8031 6.9875 17 7.9625 17 9C17 10.0375 16.8031 11.0125 16.4094 11.925C16.0156 12.8375 15.4812 13.6312 14.8062 14.3062C14.1312 14.9812 13.3375 15.5156 12.425 15.9094C11.5125 16.3031 10.5375 16.5 9.5 16.5Z",
    fill: "#864BFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.10bd7e5a815011f00391525fa9d5c8f0.svg";
export { ForwardRef as ReactComponent };